import React from 'react'
import IconLabel from '../../common/icon-label'
import { PeopleFill, Incognito } from 'react-bootstrap-icons'
import { get } from 'lodash'
import Enrollees from './enrollees'
import ViewEnrolleesButton from './view-enrollees-button'
import useCourseEnrollability from '../../user/hooks/use-user-course-enrollability'

const EnrollmentIconLabel = ({
    experience = {},
    showEnrollees
}) => {
    const [ enrolleesVisible, setEnrolleesVisible ] = React.useState(false)
    const { conflicts } = useCourseEnrollability({ courseId: experience.id })
    const maxCapacity = get(experience, 'maxCapacity', 0)
    const enrollees = get(experience, 'enrollees', [])
    const spotsAvailable = maxCapacity - enrollees.length

    const renderLabel = () => {
        if (spotsAvailable <= 0) {
            return 'FULL'
        }
        return `${spotsAvailable} / ${maxCapacity} spots left`
    }

    const renderConflict = () => {
        if (conflicts.length) {
            return (
                <span
                    style={{
                        paddingLeft: '10px',
                        color: 'red'
                    }}
                >
                    (CONFLICT)
                </span>
            )
        }
    }

    if (experience.isSecretEnrollment) {
        return (
            <IconLabel
                icon={Incognito}
                color={!spotsAvailable ? 'red' : undefined}
            >
                {renderConflict()}
            </IconLabel>
        )
    }

    return (
        <div>
            <IconLabel
                icon={PeopleFill}
                color={!spotsAvailable ? 'red' : undefined}
            >
                {renderLabel()}
                {renderConflict()}
                <ViewEnrolleesButton experience={experience} disabled={!showEnrollees} active={enrolleesVisible} onClick={() => setEnrolleesVisible(!enrolleesVisible)}/>
            </IconLabel>
            {enrolleesVisible && <div><Enrollees experience={experience} /></div>}
        </div>
        
    )
}

export default EnrollmentIconLabel